module.exports = /:[\d+_a-z-]+:/;
